import http from "@/utils/request";

export default {
  authorize: request =>
    http.sendRequest({
      METHOD_NAME: "warehouseReceiptAuthorization.authorize",
      SECURITY_TYPE: "UserLogin",
      data: { request },
      ERROR_CODE: {}
    })
};
